import { lazy } from "react";
const InquiryManagement = lazy(() => import("@/pages/inquiryManagement/page"));

const inquiryRoute = [
  {
    path: "/inquiryManagement",
    name: "询比价管理",
    component: InquiryManagement,
  },
];
export default inquiryRoute;
